import { useUpdateCategoryApi } from 'apis/product-category/use-update-category-api';
import {
  BoxProps,
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  VStack,
} from 'design-system';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { TreeViewSection } from './tree-view-section';

export interface IMoveCategoryModalCell extends BoxProps {
  trigger: JSX.Element;
}

/** Moves the open category under another parent. */
export const MoveCategoryModal = ({ trigger }: IMoveCategoryModalCell) => {
  const params = useParams<any>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isLoading, mutate: updateCategory } = useUpdateCategoryApi(params?.categoryId);
  const [activeId, setActiveId] = useState(0);

  const handleClick = () => {
    updateCategory({ categoryId: params?.categoryId, body: { parentId: activeId } }, { onSuccess: onClose });
  };

  return (
    <>
      {React.cloneElement(trigger, { onClick: onOpen })}

      <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} size='sm'>
        <ModalOverlay />
        <ModalContent maxHeight='600px' minWidth='720px'>
          <ModalHeader>
            Move Category
            <Text color='gray.500' fontWeight='semibold' fontSize='md'>
              Please select from below the category you want to move this item to.
            </Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody overflow={'auto'}>
            <VStack spacing='md' alignItems='stretch' py='md'>
              <TreeViewSection setActiveIdd={setActiveId} isModal={true} />
            </VStack>
          </ModalBody>
          <ModalFooter>
            <HStack spacing='md'>
              <Button variant='outline' colorScheme='red' onClick={onClose}>
                Cancel
              </Button>
              <Button
                variant='solid'
                isLoading={isLoading}
                colorScheme='red'
                type='submit'
                onClick={handleClick}
                form='AddCategoryModal'>
                Confirm
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
